import { useEffect, useState } from "react";
import { SpellDto } from "../../../Types/ApiTypes";
import { getTranslation } from "../../../Utils/Converters";
import SpellModal from "./SpellModal";
import { deleteSpell, getSource } from "../../../Utils/LocalApi";

interface SpellRowItemComponentProps{
    spell: SpellDto,
    deleteSpell: (id?: number) => void
}


const SpellRowItemComponent = (props: SpellRowItemComponentProps)=>{
    const [spell, setSpell] = useState({} as SpellDto);
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(() => {
        setSpell(props.spell);
    },[props.spell])

    return(
        <>
            <tr>
                <td>{spell.id}</td>
                <td>{spell.source ? spell.source.year+" "+getTranslation(spell.source.name) : ""}</td>
                {/* <td>{spell.index}</td> */}
                <td>{spell.name ? getTranslation(spell.name) : ""}</td>
                <td>{spell.school ? getTranslation(spell.school) : ""}</td>
                <td className="text-center">
                    <span>
                        <input 
                            name="reaction" 
                            type="checkbox"
                            className='form-check-input'
                            style={{maxWidth: "24px", maxHeight: "24px", outlineStyle:"auto", outlineColor: "darkgray"}}
                            checked={spell.ritual}
                            disabled
                        ></input>
                    </span>
                </td>
                <td className="text-center">
                    <span>
                        <input 
                            name="reaction" 
                            type="checkbox"
                            className='form-check-input'
                            style={{maxWidth: "24px", maxHeight: "24px", outlineStyle:"auto", outlineColor: "darkgray"}}
                            checked={spell.concentration}
                            disabled
                        ></input>
                    </span>
                </td>
                <td>{spell.classes ? getTranslation(spell.classes) : ""}</td>
                <td>{spell.castingTime ? getTranslation(spell.castingTime) : ""}</td>
                <td>
                    <span role="button"
                        onClick={(e => {
                            setIsModalOpen(true);
                        })}
                    >
                        <i className="bi bi-pencil-square"></i>
                    </span>
                     &nbsp;
                    <span role="button"
                        onClick={(e => {
                            let id = props.spell.id;
                            if (id) {
                                deleteSpell(id).then((result) => {
                                    if (result >= 200 && result < 300){
                                        props.deleteSpell(id)
                                    }
                                });
                            }
                        })}
                    >
                        <i className="bi bi-trash"></i>
                    </span>
                    {isModalOpen && 
                    <SpellModal
                        spell={spell}
                        updateSpell={setSpell}
                        deleteSpell={(id?: number)=>{props.deleteSpell(id)}}
                        closeModal={()=>{setIsModalOpen(false)}}
                    />}
                </td>
            </tr>
            
        </>
    )
}
export default SpellRowItemComponent;